import { render } from "./shopStatistics.vue?vue&type=template&id=679b030c"
import script from "./shopStatistics.vue?vue&type=script&lang=js"
export * from "./shopStatistics.vue?vue&type=script&lang=js"

import "./shopStatistics.vue?vue&type=style&index=0&id=679b030c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__